// extracted by mini-css-extract-plugin
export default {"spriteContainer":"EquipmentSprite_spriteContainer__VBcIc","accuracy":"EquipmentSprite_accuracy__VR-dB"};